import React, {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import Loader from "../../loader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLock} from "@fortawesome/pro-thin-svg-icons";
import {fetchPaymentLinkData} from "../../api/paymentLinks/fetchPaymentLinkData";
import {proceedToPayment} from "../../api/paymentLinks/proceedToPayment";

function PaymentLinkPaymentComponent() {
    const [isPaid, setIsPaid] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [errorStatus, setErrorStatus] = useState(null);
    const [errorDetail, setErrorDetail] = useState(null);
    const [data, setData] = useState('');
    const {'*': fullPath} = useParams();
    const ref = fullPath.split('_').pop();
    const parts = fullPath.split('-');
    const merchantPart = parts.find(part => part.startsWith('m_'));
    const merchantRef = merchantPart ? merchantPart.split('_')[1] : null;
    const [isDisable, setIsDisable] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const paymentData = await fetchPaymentLinkData(ref, merchantRef);
                setData(paymentData);

                setIsDisable(!paymentData?.is_active);

                if (paymentData?.payment_status === "Paid") {
                    setIsPaid(true);
                }

            } catch (error) {
                if (error?.response) {
                    setErrorStatus(error?.response?.status);
                    if (error?.response?.status === 404) {
                        setErrorDetail('Payment link not found');
                    } else {
                        setErrorDetail(error?.response?.data?.detail || 'An unexpected error occurred');
                    }
                } else {
                    setErrorStatus(error?.response?.status);
                    setErrorDetail(error?.message || 'An unexpected error occurred');
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);


    const handleProceedToPayment = async () => {
        setIsLoading(true);
        try {
            const paymentData = await proceedToPayment(data?.link_reference, data?.merchant_reference);
            if (paymentData?.payment_url) {
                window.location.replace(paymentData?.payment_url);
            } else {
                throw new Error('No payment URL received');
            }
        } catch (error) {
            if (error?.response) {
                if (error?.response?.status === 410) {
                    setIsPaid(true);
                }
                setErrorStatus(error?.response?.status);
                setErrorDetail(error?.response?.data?.detail || 'An unexpected error occurred');
            } else {
                setErrorStatus(500);
                setErrorDetail(error?.message || 'An unexpected error occurred');
            }
            setIsLoading(false);
        }

    };

    if (isLoading) {
        return (<div className="z-50 w-screen h-screen bg-white fixed inset-0 flex items-center justify-center">
            <Loader/>
        </div>);
    }

    if (isDisable) {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <div className="mt-4 mb-2 mx-auto">
                    <img
                        src="/hellopay.svg"
                        className="my-2 sm:mb-8 mx-auto w-auto h-[50px]"
                        alt={"logo"}
                    />
                    <img
                        src="/hellopayFailedIcon.svg"
                        className="mt-4 mb-2 mx-auto h-[200px] sm:h-[300px] w-auto"
                        alt={"logo"}
                    />
                </div>

                <div className="flex space-x-2 my-2 sm:mt-6 font-bold text-[32px] sm:text-[40px]">
                    <p className="text-center uppercase text-3xl font-bold tracking-wide">
                        <span className="text-black">Payment link </span>
                        <span className="text-red">is disabled</span>
                    </p>
                </div>
            </div>
        );
    }


    if (errorStatus || errorDetail) {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <div className="mt-4 mb-2 mx-auto">
                    <img
                        src="/hellopay.svg"
                        className="my-2 sm:mb-8 mx-auto w-auto h-[50px]"
                        alt={"logo"}
                    />
                    <img
                        src="/hellopayFailedIcon.svg"
                        className="mt-4 mb-2 mx-auto h-[200px] sm:h-[300px] w-auto"
                        alt={"logo"}
                    />
                </div>

                <div className="flex space-x-2 my-2 sm:mt-6 font-bold text-[32px] sm:text-[40px]">
                    {errorStatus === 404 ? (
                        <p className="text-center uppercase text-3xl font-bold tracking-wide">
                            <p className="text-black">Payment link </p>
                            <p className="text-red">not found</p>
                        </p>
                    ) : (
                        <p className="text-red-500 text-center uppercase text-3xl font-bold tracking-wide">
                            {errorDetail}
                        </p>
                    )}
                </div>
            </div>)
            ;
    }


    return (<div className="flex min-h-screen md:max-xl:flex">
        <div className="w-full flex columns-1 xl:columns-2 gap-1">
            <div className="hidden xl:block w-1/2">
                <img
                    src="/hostedPageCardsBackgroundImage.svg"
                    className="h-[90vh] w-auto"
                    alt="hostedPageCardsBackgroundImageSvg"
                />
            </div>
            <div className="w-full xl:w-1/2 flex item-center justify-center">
                <div className="px-6 py-3 w-full text-xl xl:bg-[#F8F8F8] flex min-h-screen items-center">
                    <div className="mx-auto my-auto w-full md:w-3/4 lg:w-2/3">
                        <div className="sm:mt-2 mb-4 sm:mb-6 flex justify-center">
                            <img
                                className="w-[40%] h-auto"
                                src="/hellopayPoweredByNedbank.svg"
                                alt="hellopay powered by Nedbank"
                            />
                        </div>

                        <div
                            className="mb-2 p-2 flex rounded-md space-x-2 bg-very_light_purple font-semibold hellopay_text text-purple">
                            <div className="ml-2.5"> {data?.trading_name}</div>
                        </div>
                        <div
                            className={`flex h-[90px] rounded-md mb-5 p-1.5 font-semibold hellopay_text text-purple ${isPaid ? 'bg-[#89cf32] bg-opacity-[0.36]' : 'bg-light_purple'}`}>
                            <div className="col-span-6">
                                <div className="flex items-center justify-between mt-1.5 mb-1.5 ml-4 mr-4">
                                    {isPaid ? <div className="flex items-center">
                                        <div>Paid</div>
                                    </div> : (<div className="flex items-center">
                                        <div>Total amount to pay:</div>
                                    </div>)}
                                </div>
                                <div
                                    className={`mb-1.5 ml-6 font-bold  ${isPaid ? 'text-purple ' : 'text-purple'}`}>
                                    {data?.currency_code} {data?.amount}
                                </div>
                            </div>
                            <div className="ml-auto mr-2  flex items-center">
                                {isPaid && (<img className="w-14 h-14" src="/hellopaySuccessIconPaymentLink.svg"
                                                 alt="success"/>)}
                            </div>
                        </div>

                        {(data?.description || data?.merchant_reference || data?.first_name || data?.last_name) && (
                            <div className="bg-[#DEDDF933] bg-opacity-[0.02] rounded-md px-5 mx-auto">
                                {data?.customer_reference && (<div className="py-2">
                                    <div className="text-lg font-bold text-purple">Payment Reference:</div>
                                    <div className="text-lg font-[350] text-purple break-all">{data?.customer_reference}</div>
                                </div>)}
                                {data?.description && (<div className="py-2">
                                    <div className="text-lg font-bold text-purple">Description:</div>
                                    <div
                                        className="text-lg font-[350] tracking-wider text-purple break-all">{data?.description}</div>
                                </div>)}
                                {data?.first_name && (<div className="py-2">
                                    <div className="text-lg font-bold text-purple">First Name:</div>
                                    <div className="text-lg font-[350] text-purple break-words">{data?.first_name}</div>
                                </div>)}
                                {data?.last_name && (<div className="py-2">
                                    <div className="text-lg font-bold text-purple">Last Name:</div>
                                    <div className="text-lg font-[350] text-purple break-words">{data?.last_name}</div>
                                </div>)}
                            </div>
                        )}

                        {!isPaid && (<div className="flex justify-center my-6">
                            <button
                                onClick={handleProceedToPayment}
                                className={'bg-gradient-to-r from-purple to-very_dark_grayish_violet text-sm h-10 w-full space-x-2 px-2 rounded-md text-white uppercase'}
                            >
                                <FontAwesomeIcon icon={faLock} style={{color: "#f2f2f2"}}/>
                                <span>Proceed to payment</span>
                            </button>
                        </div>)}

                    </div>
                </div>
            </div>
        </div>
    </div>);
}

export default PaymentLinkPaymentComponent;